import data from '../ourStory/data';

export default data.locations;
